import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import Header from "../common/header";
import TextSection from "../common/text-section";
import Newsletter from "../common/newsletter/newsletter-contact.jsx";
import Body from "../common/body";
import Text from "../common/text";
import Social from "../common/social";
import Clients from "./clients";
import Gutter from "../common/gutter";
import ContactForm from './contact-form';

const Footer = styled.footer`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  ${({ theme }) => theme.media.mobile} {
    flex-direction: column-reverse;
  }
`;

const FooterSection = styled.div`
  height: 180px;
  display: flex;
  flex-direction: column;
  margin-bottom: 40px;
  margin-top: 60px;

  ${({ theme }) => theme.media.mobile} {
    margin-top: 30px;
    margin-bottom: 30px;
    height: auto;
  }
`;

const IntroductionText = styled.div`
  margin-bottom: 40px;
  font-family: "Libre Baskerville", serif;
  font-size: 1rem;
  line-height: 1.5;
  
  & * {
    font-family: inherit;
    font-size: inherit;
    line-height: inherit;
  }
`;

const SocialContainer = styled.div`
.social__Image-iFcNio {
}
`;


const Contact = ({
  socials,
  socialTitle,
  address,
  email,
  title,
  subtitle,
  content,
  clients,
  contactFormIntroduction,
}) => (
  <Body>
    <Header />
    <Gutter size={64} />
    <TextSection title={title} subtitle={subtitle}>
      {content}
    </TextSection>
    <Gutter size={32} />
    <Clients logos={clients} />
    
    <Gutter
      size={5}
      css={`
        ${({ theme }) => theme.media.mobile} {
          height: 48px;
        }
      `}
    />

    {contactFormIntroduction && (
      <>
        <Gutter size={32} />
        <IntroductionText dangerouslySetInnerHTML={{ __html: contactFormIntroduction }} />
      </>
    )}
    <ContactForm />

    <Gutter
      size={5}
      css={`
        ${({ theme }) => theme.media.mobile} {
          height: 48px;
        }
      `}
    />
    <Footer>
      <FooterSection>
        <Text
          font="subtitle"
          css={`
            margin-top: 0px;
          `}
        >
          {address.map((line) => (
            <div>{line}</div>
          ))}
        </Text>
        <div>
          <Text
            font="subtitle"
            size="s"
            css={`
              margin-top: 40px;
              margin-bottom: 8px;
              display: block;
            `}
          >
            {socialTitle}
          </Text>
          <SocialContainer>
               <Social socials={socials} />
             </SocialContainer>
        </div>

        <Gutter />
        <Text font="subtitle">
          <a href={`mailto:${email}`}>{email}</a>
        </Text>
      </FooterSection>
      <FooterSection>
        <Newsletter />
        <Gutter />
      </FooterSection>
    </Footer>

  </Body>
);

Contact.propTypes = {
  socials: Social.propTypes.socials,
  socialTitle: PropTypes.string,
  address: PropTypes.arrayOf(PropTypes.string.isRequired),
  email: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  content: PropTypes.node,
  clients: Clients.propTypes.logos,
  contactFormIntroduction: PropTypes.string,
};

export default Contact;
